import { useHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import { FormField } from '@ipfabric/ui-components/FormField/FormField';
import { FormFieldError } from '@ipfabric/ui-components/FormFieldError/FormFieldError';
import { Label } from '@ipfabric/ui-components/Label/Label';
import { Switch } from '@ipfabric/ui-components/Switch/Switch';
import { memo } from 'react';
import type { WrappedFieldProps } from 'redux-form';

type ReduxFormToggleFieldProps = WrappedFieldProps & {
  label: string;
  inline?: boolean;
  validationMessages?: {
    [key: string]: string;
  };
};

export const ReduxFormToggleField = memo(
  ({
    inline,
    label,
    meta,
    validationMessages,
    input,
  }: ReduxFormToggleFieldProps) => {
    const error =
      meta.touched && meta.error
        ? (validationMessages?.[meta.error] ??
          (typeof meta.error === 'string' ? meta.error : 'Error'))
        : undefined;

    const id = useHtmlId('redux-form-toggle-field');

    return inline ? (
      <div className='flex flex-col gap-3xs'>
        <div className='flex flex-row gap-xs'>
          <Switch {...input} hasError={error !== undefined} id={id} />
          {label && (
            <Label className='mb-0' htmlFor={id}>
              {label}
            </Label>
          )}
        </div>
        {error && <FormFieldError error={error} />}
      </div>
    ) : (
      <FormField label={label} error={error}>
        <Switch {...input} hasError={error !== undefined} />
      </FormField>
    );
  },
);
